<t4-container [title]="title" [isLoading]="isLoading">
    <canvas #chart mdbChart
            [type]="chartType"
            [datasets]="chartDatasets"
            [labels]="chartLabels"
            [options]="chartOptions"
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)"></canvas>
</t4-container>
